import { render, staticRenderFns } from "./VeJwPkmxList.vue?vue&type=template&id=254ac4c9"
import script from "./VeJwPkmxList.vue?vue&type=script&lang=js"
export * from "./VeJwPkmxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports